import gql from 'graphql-tag';

export const DELETE_CREATIVE_TEMPLATE_MUTATION = gql`
  mutation DeleteCreativeTemplateMutation($id: ID!) {
    deleteCreativeTemplate(id: $id) {
      creativeTemplate {
        id
      }
      errors
    }
  }
`;
